module.exports = __webpack_public_path__ + "img/logo.c623d2ad.png";